var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.b()},[_c('div',{staticClass:"text--secondary",class:_vm.b('title')},[_vm._v("Dictámenes anteriores")]),_c('div',{class:_vm.b('list')},_vm._l(([..._vm.opinions].reverse()),function(opinion){return _c('opinion-item',{key:opinion.id,attrs:{"opinion":opinion,"currency":_vm.currency}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }